module.exports = __webpack_public_path__ + "img/6-2.b53a3057.png";